import { ClientUser, LoginUser, Page, RegisterUser, User } from "@/tracker-types";
import { axiosInstance, loginAxiosInstance } from "./utils/axiosInterceptor";

export const USER_CACHE_KEY = "/user";

export async function loginUser(data: LoginUser) {
  //console.log("waar gaat het fout?");
  const response = await loginAxiosInstance.post("/user/login", data);
  return response.data;
}

export async function registerUser(data: RegisterUser) {
  const response = await loginAxiosInstance.post("/user/register", data);
  return response.data;
}

export async function addClient(data: Partial<RegisterUser> & { isTrainerAdded: boolean; firstName: string; lastName: string }) {
  const response = await axiosInstance.post("/user/add-client", data);
  return response.data;
}

export async function getPagedUsers(page: string, size: number): Promise<Page<User>> {
  const response = await axiosInstance.get<Page<User>>(`${USER_CACHE_KEY}/paged`, {
    params: { page, size },
  });

  return response.data;
}

export async function getPagedClients(trainerId: number | string, page: string, size: number): Promise<Page<ClientUser>> {
  const response = await axiosInstance.get<Page<ClientUser>>(`/user/trainer/${trainerId}/clients/paged`, {
    params: { page, size },
  });

  return response.data;
}


export async function getUser(id: number | string | undefined) {
  const response = await axiosInstance.get(`/user/${id}`);
  return response.data;
}

export async function getClientsSelect(trainerId: number | string | undefined) {
  const id = trainerId;
  const response = await axiosInstance.get(`/user/select/${id}`);
  return response.data.clients;
}

export async function getReferralCode(userId: number | string | undefined) {
  if (!userId) throw new Error("User ID is required");
  const response = await axiosInstance.get(`/user/referral/${userId}`);
  return response.data;
}

export async function updateUser(id: number, data: Partial<User>): Promise<User> {
  const response = await axiosInstance.put(`/user/${id}`, data);
  return response.data;
}

export async function updatePassword(
  id: number,
  data: { oldPassword: string; newPassword: string }
): Promise<Record<string, unknown>> {
  const response = await axiosInstance.put(`/user/password/${id}`, data);
  return response.data as Record<string, unknown>;
}

export async function requestPasswordReset(email: string) {
  const response = await loginAxiosInstance.post("/user/request-password-reset", { email });
  return response.data;
}

export async function verifyResetToken(token: string) {
  const response = await loginAxiosInstance.get(`/user/verify-reset-token/${token}`);
  return response.data;
}

export async function resetPassword(token: string, newPassword: string) {
  const response = await loginAxiosInstance.post("/user/reset-password", { token, newPassword });
  return response.data;
}

export async function logoutUser() {
  const response = await axiosInstance.post("/user/logout");
  return response.data;
}

export async function validateSession() {
  try {
    const response = await axiosInstance.get("/user/validate-session");
    return response.data;
  } catch {
    return null;
  }
}
